import { createSlice } from "@reduxjs/toolkit";
import { DEProcess } from "../models/caster.models";
import { ReadyToCastHeat } from "../models/catalogs.models";

const DataEntryReducerInitialState: {
  isDataLoading: boolean;
  isSubmitLoading: boolean;
  errorMessage: string;
  notificationMessage: string;
  heats: ReadyToCastHeat[];
  heatSelected: ReadyToCastHeat | null;
  deProcess: DEProcess | null;
  lastUpdate: Date;
  selectedStrandLossId: number | null;
  showJustifyAllStrandLosses: boolean;
  isJustifyingAllStrandLosses: boolean;
} = {
  errorMessage: "",
  notificationMessage: "",
  isDataLoading: false,
  isSubmitLoading: false,
  heats: [],
  heatSelected: null,
  deProcess: null,
  lastUpdate: new Date(),
  selectedStrandLossId: null,
  showJustifyAllStrandLosses: false,
  isJustifyingAllStrandLosses: false,
};

export const DataEntryReducer = createSlice({
  name: "__",
  initialState: DataEntryReducerInitialState,
  reducers: {
    setIsDataLoading(state, { payload }) {
      state.isDataLoading = payload;
    },
    setIsSubmitLoading(state, { payload }) {
      state.isSubmitLoading = payload;
    },
    setErrorMessage(state, { payload }) {
      state.errorMessage = payload;
    },
    setNotificationMessage(state, { payload }) {
      state.notificationMessage = payload;
    },
    setDEProcess(state, { payload }) {
      state.deProcess = payload;
    },
    setHeats(state, { payload }) {
      state.heats = payload;
    },
    setHeatSelected(state, { payload }) {
      state.heatSelected = payload;
    },
    setProcess(state, { payload }) {
      if (state.deProcess) {
        state.deProcess.process = payload;
      }
      state.deProcess;
    },
    setLastUpdate(state) {
      state.lastUpdate = new Date();
    },
    setSelectedStrandLossId(state, { payload }) {
      state.selectedStrandLossId = payload;
    },
    setShowJustifyAllStrandLosses(state, { payload }) {
      state.showJustifyAllStrandLosses = payload;
    },
    setIsJustifyingAllStrandLosses(state, { payload }) {
      state.isJustifyingAllStrandLosses = payload;
    },
  },
});
